import { render } from "./commonComponent.vue?vue&type=template&id=664cc8bd&scoped=true"
import script from "./commonComponent.vue?vue&type=script&lang=js"
export * from "./commonComponent.vue?vue&type=script&lang=js"

import "./commonComponent.vue?vue&type=style&index=0&id=664cc8bd&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664cc8bd"]])

export default __exports__